define('services/auth/filter',['require','exports','module'],function(require, exports, module) {
  "use strict";

  module.exports = function(authInfo, authHandler) {
    return {
      init: function() {
        $.ajaxPrefilter(function(options, originalOptions, xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + authInfo.getAccessToken());
        });
        $(document).ajaxError(function(event, xhr, settings, thrownError) {
          authHandler.handle(xhr.status);
        });
      },
    };
  };

});

